import React from 'react';
import {has as _has} from 'lodash';

import {IconCheckmark, IconVideoTrimWithTooltip} from '@appComponents/IconCollection';
import {convertToInt, getName} from '@utils/helpers';
import {
    hasEncodingJobProfileDRMSupportEnabled,
    hasEncodingTargetDRMSupportEnabled,
    hasNoClientCdnConfigurationsForSpott,
    showInfoDrmIcon,
    showInfoSpottIcon,
    showInfoWatermarkingIcon,
} from '@modules/events/utils/eventsConfigurationTargetsTableHelper';
import {NO_ASSOC_CDN_CONFIGS, NO_ASSOC_VOD_STORAGES, NO_WATERMARKING_CONFIG} from '@constants/messages';
import {convertSecondsToMinutes} from '@utils/momentWrapper';
import {DISTRIBUTION_TYPE_RECORDING} from '@constants/variables';

export const renderCheckbox = (row, column) => {
    return (
        (null === row[column] || row[column] === undefined || false === row[column]) ? '' : <IconCheckmark/>
    );
};

export const renderListOfNameOfFirstLevelDependency = (row, column) => {
    return row[column].map((item => (item.name))).join(', ');
};

export const setCdnColumn = (column, row) => {
    const cdnName = getName(row[column]),
        akamaiCdnIngestMethodName = _has(row, 'akamai_cdn_ingest_method.name')
            ? ` - ${row.akamai_cdn_ingest_method.name}`
            : '';

    return cdnName
        ? (cdnName + akamaiCdnIngestMethodName)
        : '';
};

export const getDrmInfoText = (row) => {
    if (hasEncodingTargetDRMSupportEnabled(row) && !hasEncodingJobProfileDRMSupportEnabled(row)) {
        return 'This encoding target has DRM enabled but its encoding job profile does not support DRM.';
    } else if (!hasEncodingTargetDRMSupportEnabled(row) && hasEncodingJobProfileDRMSupportEnabled(row)) {
        return 'This encoding target has DRM disabled but its encoding job profile supports DRM.';
    }

    return '';
};

export const getIconWarningText = (row) => {
    const textTooltip = [];

    if (showInfoSpottIcon(row)) {
        textTooltip.push(
            <>
                {(hasNoClientCdnConfigurationsForSpott(row) ? NO_ASSOC_CDN_CONFIGS : NO_ASSOC_VOD_STORAGES)}
                <br />
            </>
        );
    }

    if (showInfoDrmIcon(row)) {
        textTooltip.push(<>{getDrmInfoText(row)}</>);
    }

    if (showInfoWatermarkingIcon(row)) {
        textTooltip.push(
            <>
                {NO_WATERMARKING_CONFIG}
            </>
        );
    }

    return textTooltip;
};

export const sortTargets = (row) => {
    return row.distribution_type ? `${row.product.id} - ${row.distribution_type.id}` : null;
};

export const renderDistributionType = (props) => {
    const {distribution_type, trimming_type, trimming_start_margin, trimming_end_margin} = props;

    if (!distribution_type || !trimming_type) return null;

    const trimmingData = [
        {
            header: 'Type',
            body: `${trimming_type.name}`,
        },
        {
            header: 'Start margin',
            body: `${convertSecondsToMinutes(trimming_start_margin)} min`,
        },
        {
            header: 'End margin',
            body: `${convertSecondsToMinutes(trimming_end_margin)} min`,
        },
    ];

    return (
        <span className='--distributionType-section'>
            {distribution_type.name}
            {convertToInt(distribution_type.id) === DISTRIBUTION_TYPE_RECORDING
                ? <IconVideoTrimWithTooltip rows={trimmingData}/> : null
            }
        </span>
    );
};
